import { Component, OnInit } from '@angular/core';
import { TicketService, Ticket, TicketPage } from '../../services/ticket.service';
import { CondominiumService } from '../../services/condominium.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-tickets-all',
    templateUrl: './tickets-all.component.html',
    styleUrls: ['./tickets-all.component.sass'],
    standalone: false
})
export class TicketsAllComponent implements OnInit {
  tickets: Ticket[] = [];
  isLoading = true;
  currentPage = 0;
  pageSize = 10;
  totalElements = 0;
  condominiumId: number | null = null;

  statusForm: UntypedFormGroup;

  constructor(
    private ticketService: TicketService,
    private condominiumService: CondominiumService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder
  ) {
    this.statusForm = this.fb.group({
      open: [true],
      inProgress: [true],
      closed: [false]
    });
  }

  ngOnInit(): void {
    this.route.parent?.url.subscribe(url => {
      let found = false;
      if (url[0].path === 'condominium' && url.length > 1) {
        this.condominiumId = +url[1];
        this.loadTickets();
        found = true;
      }
      if (!found) {
        this.router.navigate(['/condominiums']);
      }
    });
    
    this.statusForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe(() => {
        this.currentPage = 0;
        this.loadTickets();
      });
  }

  loadTickets(): void {
    if (!this.condominiumId) {
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    this.ticketService.getTickets(this.condominiumId, this.currentPage, this.pageSize).subscribe({
      next: (response: TicketPage) => {
        this.tickets = response._embedded?.getTicketList;
        this.totalElements = response.page.totalElements;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading tickets:', error);
        this.isLoading = false;
      }
    });
  }

  private getSelectedStatuses(): string[] {
    const statuses: string[] = [];
    const formValue = this.statusForm.value;
    
    if (formValue.open) statuses.push('OPEN');
    if (formValue.inProgress) statuses.push('IN_PROGRESS');
    if (formValue.closed) statuses.push('CLOSED');
    
    return statuses;
  }

  onPageChange(event: PageEvent): void {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadTickets();
  }

  navigateToCreateTicket(): void {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/ticket/create`]);
    } else {
      this.router.navigate(['/condominiums']);
    }
  }
}
